// Mirror the backend ActivityLogEventActions constants
export const ActivityLogEventActions = {
    UserRegistered: "UR",
    UserSkillAdded: "USA",
    UserTeamAdded: "UTA",
    UserSkillRemoved: "USR",
    UserDeactivated: "UD",
    RegistrationApproved: "RA",
    PhoneNbrUpdated: "PNU",
    InQueue: "IQ",
    ClaimedShift: "CS",
    ShiftCreated: "SC",
    ShiftPosted: "SP",
    ShiftApproved: "SA",
    ShiftDenied: "SD",
    EmailAddressUpdated: "EAU",
    UserActivated: "UA", 
};